export default __webpack_public_path__ + "static/media/d3014c46dee9c041a2010b374ff74f321581087101476.f2baa341.webp";